import { CHUNK_SIZE } from './local-import.constants';
import { Folder } from './local-import.entity';
import { FileStatus } from './local-import.enum';
import { ImportFileInfo } from './local-import.interface';

export function organizeFiles(fileList: ImportFileInfo[]): Folder {
  const root = new Folder('root');

  fileList.forEach(file => {
    const pathParts = file.fileName.split('/');
    let currentFolder = root;

    for (let i = 0; i < pathParts.length - 1; i++) {
      currentFolder = currentFolder.getDir(pathParts[i]) ?? currentFolder.addDir(pathParts[i]);
    }

    currentFolder.addFile(file);
  });

  root.updateSizeAndFileCount();
  root.updateStatus();

  if (!root.dirList.length) {
    return root;
  }

  return root;
}

export function getStatusClass(status: FileStatus): 'green' | 'slate' | 'red' | undefined {
  switch (status) {
    case FileStatus.Complete:
      return 'green';
    case FileStatus.InProgress:
      return 'slate';
    case FileStatus.Error:
      return 'red';
    default:
      return undefined;
  }
}

export function trackByForFolder(index: number, folder: Folder): string {
  return [index, folder.name].join('');
}

export function trackByForFile(index: number, file: ImportFileInfo): string {
  return [index, file.fileName, file.size].join('');
}

export function areFilesEqual(fileInfo1: ImportFileInfo, fileInfo2: ImportFileInfo): boolean {
  const file1 = fileInfo1.file;
  const file2 = fileInfo2.file;

  return fileInfo1.fileName === fileInfo2.fileName && file1.size === file2.size;
}

export function areFilesInSameDir(fileInfo1: ImportFileInfo, fileInfo2: ImportFileInfo): boolean {
  return getParentDir(fileInfo1.fileName) === getParentDir(fileInfo2.fileName);
}

export function getParentDir(filePath: string): string {
  return filePath.substring(0, filePath.lastIndexOf('/'));
}

export function chunksToFile(
  chunks: Blob[],
  fileName: string,
  mimeType = 'application/dicom',
): File {
  return new File(chunks, fileName, { type: mimeType });
}


export function splitFileIntoChunks(file: File, chunks: Blob[] = [], start = 0): Blob[] {
  while (start < file.size) {
    const chunkSize = Math.min(file.size - start, CHUNK_SIZE)
    chunks.push(file.slice(start, start + chunkSize))
    start += chunkSize
  }

  return chunks
}
